import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { TxFormModule } from '@app/shared/tx/form/tx-form.module';
import { PaginatorComponent } from './paginator.component';
import { PagerComponent } from './pager/pager.component';
// import { TxDirectiveModule } from '@app/shared/tx/directives/tx-directive.module';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  declarations: [PaginatorComponent, PagerComponent],
  exports: [PaginatorComponent]
})
export class PaginatorModule {}
